var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    { attrs: { role: "button", "data-href": _vm.disabled ? "#" : _vm.link } },
    [
      _c(
        "button",
        {
          class: _vm.isOutline
            ? "btn btn-outline-primary actionar btn-block"
            : "btn btn-primary actionar btn-block",
          attrs: { type: "button", disabled: _vm.disabled },
        },
        [
          _c("span", [_vm._t("default")], 2),
          _vm._v(" "),
          _c("br"),
          _vm._v("\n        " + _vm._s(_vm.title) + "\n    "),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }